import { Action, ActionsList } from 'components';
import { useIsFormEditable } from 'hooks';
import { TranslationPath, useTranslation } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';
import { Colors } from 'libs/ui/theme';
import { DirectoryRecordActionType } from 'modules/directory/directoryRecord/types';

import { useDirectoryRecordFormHeaderActions } from './useDirectoryRecordFormHeaderActions';

export interface FormHeaderActionsProps {
  isArchived: boolean;
  isCanEdit: boolean;
  onArchive: (() => void) | undefined;
  onDearchive: (() => void) | undefined;
}

const ACTION_MAP: {
  [key in 'archived' | 'active']: {
    label: TranslationPath;
    Icon: (typeof Icon)[keyof typeof Icon];
    type: DirectoryRecordActionType;
    color?: Colors | string;
  }[];
} = {
  archived: [
    {
      label: 'common.dearchive',
      Icon: Icon.RotateRightCheck,
      type: DirectoryRecordActionType.dearchive,
    },
  ],
  active: [
    {
      label: 'common.archive',
      Icon: Icon.TimeSleep,
      type: DirectoryRecordActionType.archive,
    },
    {
      label: 'common.edit',
      Icon: Icon.Edit,
      type: DirectoryRecordActionType.edit,
    },
  ],
};

export const FormHeaderActions = ({
  isArchived,
  isCanEdit,
  onArchive,
  onDearchive,
}: FormHeaderActionsProps) => {
  const editable = useIsFormEditable();
  const { t } = useTranslation();

  const { menuActions, onClickAction } = useDirectoryRecordFormHeaderActions({
    isCanEdit,
    onArchive,
    onDearchive,
  });

  const actions = isArchived ? ACTION_MAP.archived : ACTION_MAP.active;

  return !editable
    ? !!menuActions.length && (
        <ActionsList>
          {actions.map((action) => {
            const { Icon } = action;
            return (
              <Action
                key={action.type}
                tooltip={t(action.label)}
                onClick={() => onClickAction(action.type)}
              >
                <Icon color={action.color} size={16} />
              </Action>
            );
          })}
        </ActionsList>
      )
    : null;
};
